import React from 'react';
import './hero.css';
import './loading.css';
import { Button } from '../Button/button';
import Footer from '../footer/Footer';

import { getAuth } from 'firebase/auth';
import { app } from '../../firebase/firebase-config';

const auth = getAuth(app);

class Hero extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
        };
    }

    componentDidMount() {
        auth.onAuthStateChanged((user) => {
            if (user) {
                this.setState({ isLoggedIn: true });
            } else {
                this.setState({ isLoggedIn: false });
            }
        });
    }

    render() {
        const { isLoggedIn } = this.state;

        return (
            <>
                <div className="hero">
                    <div className="hero-container d-flex flex-column justify-content-between m-0 p-0 h-100">
                        <div>
                            <h2 style={{ fontWeight: 'bold' }}>Meet</h2>
                            <h1>Woo Woo Network</h1>
                        </div>

                        <div className='d-flex flex-column-reverse gap-5 w-md-50 justify-content-center flex-md-row align-items-center w-100'>
                            <div className='d-flex flex-column justify-content-center align-items-center gap-2 me-md-5'>
                                <p className='mb-md-4'>We Connect healers to clients <br />
                                    needing a healing service</p>
                                <div className='d-flex flex-column gap-2 w-100 flex-md-row align-items-center justify-content-center'>
                                    <a href="/search">
                                        <Button>Find Healers</Button>
                                    </a>

                                    {/* This part now works correctly */}
                                    {!isLoggedIn && (
                                        <a href="/login" className="text-blue-600 hover:text-blue-800 transition duration-300 ease-in-out text-sm sm:text-base text-center w-full sm:w-auto">
                                            <span>
                                                Don't have an account yet? <br />
                                                <span className="underline">Register Here</span>
                                            </span>
                                        </a>
                                    )}
                                </div>
                            </div>
                            <img src='./Hero.png' width={300} className='ms-md-5' />
                        </div>

                        <div className="divider-container position-relative">
                            <img src="/divider.png" height={150} id="section-divider" className="w-100" />
                            <a href="#about" className="abt-link position-absolute top-50 start-50 translate-middle">
                                About Us
                            </a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Hero;
